/** Shared title + canonical rules for SEOHead and the build-time prerender. */
export const SITE_BASE_URL = "https://perfectezorgmatch.nl";
const BRAND = "Perfecte Zorgmatch";
const SUFFIX = ` | ${BRAND}`;
const MAX_TITLE_LENGTH = 60;

/** Cut at the last word boundary within max, without trailing punctuation or separators. */
export function truncateAtWord(text: string, max = MAX_TITLE_LENGTH): string {
  const clean = text.replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max + 1);
  const space = cut.lastIndexOf(" ");
  const base = space > 0 ? cut.slice(0, space) : clean.slice(0, max);
  return base.replace(/[\s.,;:!?\-–—|/(&+]+$/u, "").trim();
}

/** Only append the brand suffix when it keeps the title within 60 characters; else shorten the title itself. */
export function buildSeoTitle(title: string): string {
  const clean = title.replace(/\s+/g, " ").trim();
  return clean.includes(BRAND) || clean.length + SUFFIX.length > MAX_TITLE_LENGTH
    ? truncateAtWord(clean)
    : `${clean}${SUFFIX}`;
}

/** Absolute canonical URL; falls back to the given path (never the homepage by default). */
export function buildCanonical(canonicalUrl: string | undefined, currentPath: string): string {
  if (canonicalUrl) {
    return canonicalUrl.startsWith("http") ? canonicalUrl : `${SITE_BASE_URL}${canonicalUrl}`;
  }
  const clean = (currentPath || "/").split(/[?#]/)[0] || "/";
  const path = clean.length > 1 ? clean.replace(/\/+$/, "") : clean;
  return `${SITE_BASE_URL}${path}`;
}
